/* eslint-disable */

import {LogSource} from "commerceAPI/custom-apis/CustomShopperSystem/ICustomShopperSystem";

/**
 * Represents AbstractLogProvider
 */
abstract class AbstractLogProvider {
	/**
	 * Logs error level message
	 * @param {String} title - title
	 * @param {String} source - source
	 * @param {Object} stackTrace - stackTrace
	 */
	error(title: string, source: LogSource.COMPONENT, stackTrace: object) {}

	/**
	 * Logs warning level message
	 * @param {String} title - title
	 * @param {String} source - source
	 * @param {Object} stackTrace - stackTrace
	 */
	warning(title: string, source: LogSource.COMPONENT, stackTrace: object,) {}

	/**
	 * Logs debug level message
	 * @param {String} title - title
	 * @param {String} source - source
	 * @param {Object} stackTrace - stackTrace
	 */
	debug(title: string, source: LogSource.COMPONENT, stackTrace: object,) {}

	/**
	 * Logs info level message
	 * @param {String} title - title
	 * @param {String} source - source
	 * @param {Object} stackTrace - stackTrace
	 */
	info(title: string, source: LogSource.COMPONENT, stackTrace: object,) {}
}

export default AbstractLogProvider;
